import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// Shared UI Library Components
import { CustomButton } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './user-data.scss';

// Components
import { GeneralData } from '../general-data/general-data';
import { UserPhoto } from '../user-photo/user-photo';
import { AddCounsellorModal } from '../../../../modals/add-counsellor-modal/add-counsellor-modal';

// Store entities
import { getUserState } from '../../../../store/user/user.selectors';

type TUserDataProps = {};

export const UserData: FC<TUserDataProps> = (
  {}: TUserDataProps
) => {
  const [addModalOpen, setAddModalOpen] = useState<boolean>(false);

  const { user } = useSelector(getUserState);

  const navigate = useNavigate();

  const initialData = {
    first_name: user?.first_name ?? '',
    last_name: user?.last_name ?? '',
    email: user?.email ?? ''
  };

  const toggleAddCounsellorModal = (): void => {
    setAddModalOpen(prevState => !prevState);
  }

  const onCounsellorCreatedHandler = (): void => {
    toggleAddCounsellorModal();
    navigate(`/counsellors/${ user?.id }`);
  }

  return (
    <div className="user-data">
      <AddCounsellorModal open={ addModalOpen }
                          initialData={ initialData }
                          isCompanyOwner={ true }
                          onCancel={ toggleAddCounsellorModal }
                          onSubmit={ onCounsellorCreatedHandler }/>
      <div className="user-data--header">
        <div className="header-title">
          Personal Data
        </div>
        { user?.is_counsellor === false && <div className="header-action">
          <CustomButton type={ 'primary' } text={ 'Make Me a Consultant' }
                        onClick={ toggleAddCounsellorModal }
                        size={ 'small' }/>
        </div> }
      </div>

      { user && <div className="user-data--body">
        <div className="body-item body-item--photo">
          <UserPhoto photo={ user?.photo ?? '' }/>
        </div>

        <div className="body-item split-items">
          <GeneralData user={ user }/>
        </div>
      </div> }
    </div>
  );
}
